import { render, staticRenderFns } from "./receiptOrder.vue?vue&type=template&id=06babdd8&scoped=true&"
import script from "./receiptOrder.vue?vue&type=script&lang=js&"
export * from "./receiptOrder.vue?vue&type=script&lang=js&"
import style0 from "./receiptOrder.vue?vue&type=style&index=0&id=06babdd8&scoped=true&lang=stylus&rel=stylesheet%2Fstylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06babdd8",
  null
  
)

component.options.__file = "receiptOrder.vue"
export default component.exports